import { ApolloProvider } from '@apollo/client';
import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { PageLoading } from './components/page-layout/page-loading';
import { GlobalStyles } from './styles/global';
import { theme } from './styles/theme';
import * as analytics from './utils/analytics';
import { client } from './utils/apollo-client';
import { AppRoutes } from './utils/app-routes';
import { config } from './utils/config';
import reportWebVitals from './utils/report-web-vitals';

// Initialize analytics
analytics.init();

// Render application
ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain={config.auth0.domain}
      clientId={config.auth0.client_id}
      audience={config.auth0.audience}
      redirectUri={config.auth0.redirect_uri}
      scope={config.auth0.scope}
    >
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <BrowserRouter>
          <ApolloProvider client={client}>
            <PageLoading>
              <AppRoutes />
            </PageLoading>
          </ApolloProvider>
        </BrowserRouter>
      </ThemeProvider>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
